import React from 'react'
import { useScrollTrigger, Slide } from '@mui/material'

interface Props {
    children: React.ReactElement
}

const HideOnScroll: React.FC<Props> = ({ children }: Props) => {
    const trigger = useScrollTrigger()

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    )
}

export default HideOnScroll
